// Mirrors SHAPE_MIN_POINTS in the backend's resources/query.py (ShapeQuery) — a
// drawn shape shorter than this is rejected server-side with a 400, so the
// frontend gates the Submit button at the same threshold instead of relying on
// the round-trip to discover it.
export const SHAPE_MIN_POINTS = 2;
